import { RawContextKey } from 'vscode/vscode/vs/platform/contextkey/common/contextkey';

const NOTEBOOK_VARIABLE_VIEW_ENABLED = ( new RawContextKey('notebookVariableViewEnabled', false));

export { NOTEBOOK_VARIABLE_VIEW_ENABLED };
